<template>
  <div class="avatar-wrapper">
    <v-avatar v-bind="this.$attrs" size="128" rounded>
      <v-btn class="remove-button" icon v-if="avatar !== url">
        <v-icon color="grey" @click="removeImage">close</v-icon>
      </v-btn>
      <img :src="avatar" alt="Avatar" style="border-radius: 4px !important; width: 100%; height: 100%; object-fit: cover;" />
      <v-file-input
        class="file-input"
        :rules="rules"
        accept="image/png, image/jpeg, image/bmp"
        prepend-icon="mdi-camera"
        hide-input
        @change="onChange"
      ></v-file-input>
    </v-avatar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import get from 'lodash-es/get'

export default {
  props: {
    user: Object,
    type: String
  },
  data: () => ({
    rules: [value => !value || value.size < 2000000 || 'Ảnh đại diện cần có dung lượng nhỏ hơn 2 MB!'],
    url: require('@/assets/default-avatar.svg')
  }),
  computed: {
    ...mapGetters('auth', ['profile']),
    avatar() {
      if (this.user && this.user.avatar && this.user.avatar.url) {
        return this.user.avatar.url
      }
      const gender = get(this.user, 'gender', '')
      if (typeof gender === 'string' && gender.length) return require(`@/assets/${gender}.jpg`)
      return require('@/assets/default-avatar.svg')
    }
  },
  methods: {
    ...mapActions('student', { uploadStudentAvatar: 'uploadAvatar', destroyStudentAvatar: 'destroyAvatar' }),
    ...mapActions('teacher', { uploadTeacherAvatar: 'uploadAvatar', destroyTeacherAvatar: 'destroyAvatar' }),
    ...mapActions('staff', { uploadStaffAvatar: 'uploadAvatar', destroyStaffAvatar: 'destroyAvatar' }),
    ...mapActions('auth', ['setAvatar']),

    onChange(file) {
      if (file) {
        this.save(file)
      }
    },
    removeImage() {
      this.$dialog.confirm({
        title: 'Xóa ảnh đại diện',
        text: 'Bạn có chắc chắn muốn xóa ảnh đại diện?',
        okText: 'Có',
        cancelText: 'Hủy',
        done: () => {
          if (this.user && this.user.avatar) {
            const destroyAction = this.getDestroyAction()
            destroyAction(this.user.avatar.id)
            if (this.type === 'staff' && this.user.id === this.profile.id) {
              this.setAvatar(null)
            }
          }
        }
      })
    },
    async save(image) {
      if (this.user) {
        if (this.user.avatar) {
          const destroyAction = this.getDestroyAction()
          destroyAction(this.user.avatar.id)
        }
        let formData = new FormData()
        formData.append('files', image)
        formData.append('refId', this.user.id)
        formData.append('ref', this.type)
        formData.append('field', 'avatar')
        
        const uploadAction = this.getUploadAction()
        const avatar = await uploadAction(formData)
        
        if (this.type === 'staff' && this.user.id === this.profile.id) {
          this.setAvatar(avatar)
        }
      }
    },
    getUploadAction() {
      switch (this.type) {
        case 'teacher': return this.uploadTeacherAvatar
        case 'student': return this.uploadStudentAvatar
        case 'staff': return this.uploadStaffAvatar
        default: return () => {}
      }
    },
    getDestroyAction() {
      switch (this.type) {
        case 'teacher': return this.destroyTeacherAvatar
        case 'student': return this.destroyStudentAvatar
        case 'staff': return this.destroyStaffAvatar
        default: return () => {}
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
.avatar-wrapper {
  position: relative;
}

.avatar-wrapper:hover .file-input,
.avatar-wrapper:hover .remove-button {
  opacity: 1;
}

.file-input {
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.remove-button {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}
</style>
